<form id="appointmentTargetForm" name="appointmentTargetForm" autocomplete="false" class="flex-column-ns">
  <!-- CSR AND SKILL TARGET -->
  <div id="agentTarget" class="smt">
    <fieldset [ngClass]="{ noFieldset: noFieldset === false }">
      <legend>{{ 'agent:contact.workspace.transfer.target_csr.parameters' | i18next }}</legend>
      <div class="flex-column-ns">
        <div class="smt flex-row-ns">
          <label for="{{ htmlidPopupCsrSkillSelection }}"
            >{{ 'agent:contact.workspace.transfer.target_csr.skills_label' | i18next }}*</label
          >
          <cng-chosen-field
            [htmlId]="htmlidPopupCsrSkillSelection"
            [resetSwitch]="skillsResetSwitch"
            [parenOrderValue]="preselectedSkills"
            [collection]="skills"
            [multiple]="true"
            [fieldPlaceholder]="'agent:contact.workspace.transfer.target_csr.skills_placeholder'"
            (callback)="onSkillSelected($event)"
            required
          >
          </cng-chosen-field>
          <span class="formError" *ngIf="!skillIsValid && showErrors" role="alert">{{
            'agent:contact.workspace.transfer.target_skill.not_valid' | i18next
          }}</span>
        </div>
        <div class="smt flex-row-ns" *ngIf="!justSkills">
          <label for="{{ htmlidPopupCsrGroupSelection }}">{{ 'agent:contact.workspace.transfer.target_csr.group_label' | i18next }}</label>
          <cng-chosen-field
            [htmlId]="htmlidPopupCsrGroupSelection"
            [resetSwitch]="groupResetSwitch"
            [multiple]="false"
            [parenOrderValue]="preselectedGroup"
            [collection]="groups"
            [fieldDisabled]="!isTeamOrGroupSelectable()"
            [fieldPlaceholder]="'agent:contact.workspace.transfer.target_csr.group_placeholder'"
            (callback)="onGroupSelected($event)"
          >
          </cng-chosen-field>
        </div>
        <div class="smt flex-row-ns" *ngIf="!justSkills">
          <label for="{{ htmlidPopupCsrTeamSelection }}">{{ 'agent:contact.workspace.transfer.target_csr.team_label' | i18next }}</label>
          <cng-chosen-field
            [htmlId]="htmlidPopupCsrTeamSelection"
            [resetSwitch]="teamResetSwitch"
            [multiple]="false"
            [parenOrderValue]="preselectedTeam"
            [collection]="teams"
            [fieldDisabled]="!isTeamOrGroupSelectable()"
            [fieldPlaceholder]="'agent:contact.workspace.transfer.target_csr.team_placeholder'"
            (callback)="onTeamSelected($event)"
          >
          </cng-chosen-field>
        </div>
        <div class="smt flex-row-ns" *ngIf="!justSkills">
          <label for="{{ htmlidPopupCsrSelection }}">{{ 'agent:contact.workspace.transfer.target_csr.csr_label' | i18next }}</label>
          <cng-chosen-field
            [htmlId]="htmlidPopupCsrSelection"
            [resetSwitch]="csrResetSwitch"
            [fieldDisabled]="!isCsrSelectable()"
            [parenOrderValue]="preselectedCsr"
            [collection]="csrs"
            [multiple]="multipleCsrEnabled"
            [fieldPlaceholder]="'agent:contact.workspace.transfer.target_csr.csr_placeholder'"
            (callback)="onCsrSelected($event)"
            (keyupCallback)="onCsrInputChanged($event)"
          >
          </cng-chosen-field>
        </div>
      </div>
    </fieldset>
  </div>
</form>
